import axios from 'axios'

export const LayoutSistImagem = (condominios, id_central, user) => {
    if (!condominios || !id_central || !Array.isArray(condominios)) {
        return false
    }

    let cond = condominios.find(cond => cond.id_central == id_central)

    if (!cond) { return }

    // tipoCamera  1 'sigmaimage', 2 'dguard', 3 'benuvem'
    if (cond.tipoCamera == 1) {
        setLayoutDigifort(cond)
    } else if (cond.tipoCamera == 2) {
        setLayoutDguard(cond)
    } else if (cond.tipoCamera == 3) {
        setLayoutBenuvem(cond, user)
    }

    return (<div></div>)
}

export const MeuMonitorDigifort = (monitores) => {
    if (monitores && monitores.length) {
        let ret = []
        for (const mon of monitores) {
            if (global.ip_local.includes(mon.ip_maquina)) {
                ret.push(mon.id)
            }
        }
        return ret[0]
    } else {
        return false
    }
}

function setLayoutDguard(cond) {
    let configs = global.dguard_center_conf
    if (!configs) {
        console.log('Não foi possivel plotar o layout na tela do operador, as configs do dguard estão vazias.')
        return false
    }
    const { usuario, senha, porta } = configs

    let layoutDguard = (cond && cond.layoutCameraVis ? cond.layoutCameraVis : false)

    if (layoutDguard) {
        let path = `http://localhost:${porta}/setlayout.cgi?layout=${layoutDguard}`
        axios.post(path, { timeout: 2000 }, { auth: { username: usuario, password: senha } })
            .then((resp) => {
                /* console.log('DGUARD RESPONDEU: ', resp) */
            })
            .catch((e) => {
                /* console.log('Erro ao setar layout de cameras no sistema de monitoramento. Erro: ', e) */
            })
    }
}

const setLayoutDigifort = (cond) => {
    let configs = global.digifort_conf
    if (!configs) {
        console.log('Não foi possivel plotar o layout na tela do operador, as configs do digifort estão vazias.')
        return false
    }

    global.sendWs('setLayoutDigifort', { id_central: cond.id_central, id_monitor: global.monitorDigifort })
}

const setLayoutBenuvem = async (cond, user) => {
    if (cond.idLayoutCameraVis == '' || cond.layoutCameraVis == '') {
        console.log('As configs da BeNuvem estão vazias')
        return false
    }

    let integration_code = user.id
    let urlCamera = cond.urlCamera

    let token = cond.token

    let body = {
        integration_code
    }

    let rota = `/mosaics/open/${cond.idLayoutCameraVis}`
    let path = urlCamera + rota

    try {
        await axios.post(path, body, { headers: { Authorization: `bearer ${token}` } })
    } catch (error) {
        console.log(error)
    }
}
